import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BusApiService } from 'src/app/services/api/bus-api.service';
import { UserApiService } from 'src/app/services/api/user-api.service';
import { MessageService } from 'src/app/services/message.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-update-self-nickname-dialog',
  templateUrl: './update-self-nickname-dialog.component.html',
  styleUrls: ['./update-self-nickname-dialog.component.scss'],
})
export class UpdateSelfNicknameDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<UpdateSelfNicknameDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private api: UserApiService,
    private message: MessageService,
    private user: UserService
  ) {}

  loading = false;
  async onOk() {
    if (this.loading || !this.data) {
      return;
    }
    try {
      this.loading = true;
      const r = await this.api.updateSelfNickname(this.data);
      if (r.status !== 0) {
        this.message.warn('未知错误');
      } else {
        this.message.open('修改成功');
        this.dialogRef.close();
        this.user.setSelf(r.data);
      }
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
